import React from 'react';
import PropTypes from 'prop-types';
import objectAssign from 'object-assign';
import Translate from './Translate';
import BookingStep from './BookingStep';
import DynamicContactInfoElement from './DynamicContactInfoElement';
import Wrapper from './Wrapper';
import CustomerContactInfoAdditionalAddress from './customerContactInfoComponents/CustomerContactInfoAdditionalAddress';
import CustomerContactInfoAdditionalPhone from './customerContactInfoComponents/CustomerContactInfoAdditionalPhone';
import CustomerContactInfoCity from './customerContactInfoComponents/CustomerContactInfoCity';
import CustomerContactInfoCustomerCountry from './customerContactInfoComponents/CustomerContactInfoCustomerCountry';
import CustomerContactInfoEmail from './customerContactInfoComponents/CustomerContactInfoEmail';
import CustomerContactInfoEmailVerify from './customerContactInfoComponents/CustomerContactInfoEmailVerify';
import CustomerContactInfoFirstName from './customerContactInfoComponents/CustomerContactInfoFirstName';
import CustomerContactInfoFloor from './customerContactInfoComponents/CustomerContactInfoFloor';
import CustomerContactInfoLastName from './customerContactInfoComponents/CustomerContactInfoLastName';
import CustomerContactInfoPhone from './customerContactInfoComponents/CustomerContactInfoPhone';
import CustomerContactInfoStreet from './customerContactInfoComponents/CustomerContactInfoStreet';
import CustomerContactInfoStreetNumber from './customerContactInfoComponents/CustomerContactInfoStreetNumber';
import CustomerContactInfoTitle from './customerContactInfoComponents/CustomerContactInfoTitle';
import CustomerContactInfoZipCode from './customerContactInfoComponents/CustomerContactInfoZipCode';
import CustomerContactInfoHOC from '../hoc/CustomerContactInfoHOC';

const CustomerContactInfo = ({
  appearance,
  order,
  updateCustomerInfo,
  errors,
  validate,
  verifyEmailValidate,
  stepIndex,
  stepTotal,
  interactCustomerInfo,
}) => {
  const renderingConf = appearance.addressFormat;

  const requiredFields = order.agency.creditAgency ? renderingConf.required_fields_credit_agencies : renderingConf.required_fields; // Default to normal customer


  const params = {
    values: order.customer,
    onChange: updateCustomerInfo,
    errors,
    validate,
    requiredFields,
    interactCustomerInfo,
  };

  const titleOptions = renderingConf.title_options || [
    {value: 'mr', label: 'Mr.'},
    {value: 'ms', label: 'Ms.'},
    {value: 'mrs', label: 'Mrs.'},
  ];

  const availableElements = {
    'street': (<CustomerContactInfoStreet key="street" {...params} />),
    'streetNumber': (<CustomerContactInfoStreetNumber key="streetNumber" {...params} />),
    'floor': (<CustomerContactInfoFloor key="floor" {...params} />),
    'additionalAddress': (<CustomerContactInfoAdditionalAddress key="additionalAddress" {...params} />),
    'zipCode': (<CustomerContactInfoZipCode key="zipCode" {...params} />),
    'city': (<CustomerContactInfoCity key="city" {...params} />),
    'customerCountry': (<CustomerContactInfoCustomerCountry
      customer={order.customer}
      key="customerCountry"
      salesMarket={order.salesMarket}
      {...params}
    />),
  };

  const contactInfoElements = [];
  let wrapperKey = 0;
  let groupsClass;
  for (const groups of renderingConf.fields_groups) {
    const groupsElements = [];
    // Wrap every subgroup with it own classes.
    for (const group of groups.field_groups) {
      const elements = [];
      for (const field of group.fields) {
        // @todo it causes warning about missed key property, so it actually should be rewritten in future.
        elements.push(availableElements[field]);
      }
      const groupClass = (typeof group.wrapper !== 'undefined') ? group.wrapper.className : '';
      groupsElements.push(<Wrapper className={groupClass} elements={elements} key={wrapperKey++} />);
    }
    // Wrap entire group with it own classes.
    groupsClass = (typeof groups.wrapper !== 'undefined') ? groups.wrapper.className : '';
    contactInfoElements.push(<Wrapper className={groupsClass} elements={groupsElements} key={wrapperKey++} />);
  }
  const NamesComponent = (
<div>
      <div className="group two-col name-wrap">
        <div className="group two-col-small">
          <CustomerContactInfoTitle
            {...params}
            customer={order.customer}
            options={titleOptions}
          />
          <CustomerContactInfoFirstName {...params} />
        </div>
        <CustomerContactInfoLastName {...params} />
      </div>

      <div className="group two-col">
        <CustomerContactInfoEmail {...params} />
        <CustomerContactInfoEmailVerify {...objectAssign({},
          params,
          {validate: verifyEmailValidate})}
        />
      </div>

      <div className="contact-info">
        <div className="phone-number-wrap group two-col">
          <CustomerContactInfoPhone {...params} order={order} />
          <CustomerContactInfoAdditionalPhone {...params} />
        </div>

        {<DynamicContactInfoElement elements={contactInfoElements} />}

      </div>
</div>
  );

  return (
    <form>
      <section className="booking-step booking-personal-info card" id="booking-personal-info">
        <div className="booking-step__inner">
          <div className="booking-step__inner2">
            <h2 className="card__header">
              <span className="card__header-prefix">
{stepIndex}
/
{stepTotal}
              </span>
              <Translate content="Who is booking?" />
            </h2>
            <section className="card__body" id="form-person-data">
              {NamesComponent}
            </section>
          </div>
        </div>
      </section>
    </form>
  );
};

CustomerContactInfo.PropTypes = {
  appearance:PropTypes.object.isRequired,
  order:PropTypes.object.isRequired,
  errors:PropTypes.object,
  validate:PropTypes.func.isRequired,
  verifyEmailValidate:PropTypes.func,
  updateCustomerInfo:PropTypes.func.isRequired,
  updateCustomerDialCode:PropTypes.func,
  updateCustomerPhone:PropTypes.func,
  interactCustomerInfo:PropTypes.func,
  stepIndex:PropTypes.number.isRequired,
  stepTotal:PropTypes.number.isRequired,
};

export default CustomerContactInfoHOC(BookingStep(CustomerContactInfo));
